import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import MailboxSerializer from "services/api/mailboxes/MailboxSerializer";
import {
  IEntityCreateFailure,
  IEntityCreateSuccess,
  IEntityDelete,
  IEntityFetch,
  IEntityUpdate,
  IEntityUpdateSuccess,
} from "store/entities/actions";
import { MailboxesActions, MailboxesActionsNames } from "store/entities/mailboxes/actions";
import { IMailbox } from "store/entities/mailboxes/interfaces";
import { ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";
import { SettingsViewActions } from "store/views/settings";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchSingle(action: IActionWithPayload<string, IEntityFetch>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.mailboxesApi.fetch, action.payload.id as string);
  if (response.result) {
    const value = MailboxSerializer.deserialize(response.result);
    yield put(MailboxesActions.fetchSuccess({ id, value }));
  } else {
    yield put(MailboxesActions.fetchFailure({ id, error: "Not found" }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* fetchCollection() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.mailboxesApi.fetchAll);

  if (response.result) {
    yield put(
      MailboxesActions.fetchCollectionSuccess({
        values: MailboxSerializer.deserializeCollection(response.result),
      })
    );
  } else {
    yield put(MailboxesActions.fetchCollectionFailure({ error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* createMailbox(action: IActionWithPayload<string, IEntityUpdate<IMailbox>>) {
  const { value: entity } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.mailboxesApi.create, entity);

  if (response.result) {
    const createdEntity = MailboxSerializer.deserialize(response.result);
    yield put(MailboxesActions.createSuccess({ id: createdEntity.id, value: createdEntity }));
  } else {
    const errorObject = response.error.error;
    yield put(MailboxesActions.createFailure({ error: errorObject.message, errorObject }));
  }
}

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'action' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars
export function* createMailboxSuccess(action: IActionWithPayload<string, IEntityCreateSuccess<IMailbox>>) {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.MAILBOX_CREATE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
  yield put(SettingsViewActions.fetchNextForwardingAddress());
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* createMailboxFailure(action: IActionWithPayload<string, IEntityCreateFailure>) {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.MAILBOX_CREATE_FAILURE, action.payload),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* updateMailbox(action: IActionWithPayload<string, IEntityUpdate<IMailbox>>) {
  const entity = action.payload.value;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.mailboxesApi.update, entity);

  if (response.result) {
    const updatedEntity = MailboxSerializer.deserialize(response.result);
    yield put(MailboxesActions.updateSuccess({ id: updatedEntity.id, value: updatedEntity }));
  } else {
    // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    yield put(MailboxesActions.updateFailure({ id: entity.id, error: response.error.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'action' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars
export function* updateMailboxSuccess(action: IActionWithPayload<string, IEntityUpdateSuccess<IMailbox>>) {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.MAILBOX_UPDATE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* updateMailboxFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.MAILBOX_UPDATE_FAILURE),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* deleteMailbox(action: IActionWithPayload<string, IEntityDelete>) {
  const { id } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.mailboxesApi.deleteMailbox, id);

  if (response.result) {
    yield put(MailboxesActions.deleteSuccess({ id }));
  } else {
    yield put(MailboxesActions.deleteFailure({ id }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* deleteMailboxSuccess() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.MAILBOX_DELETE_SUCCESS),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* deleteMailboxFailure() {
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.MAILBOX_DELETE_FAILURE),
      variant: ToastVariant.Error,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* mailboxesSagas() {
  yield all([
    takeLatest(MailboxesActionsNames.FETCH_SINGLE.REQUEST, fetchSingle),
    takeLatest(MailboxesActionsNames.FETCH_COLLECTION.REQUEST, fetchCollection),
    takeEvery(MailboxesActionsNames.CREATE.REQUEST, createMailbox),
    takeLatest(MailboxesActionsNames.CREATE.SUCCESS, createMailboxSuccess),
    takeLatest(MailboxesActionsNames.CREATE.FAILURE, createMailboxFailure),
    takeEvery(MailboxesActionsNames.UPDATE.REQUEST, updateMailbox),
    takeEvery(MailboxesActionsNames.UPDATE.SUCCESS, updateMailboxSuccess),
    takeEvery(MailboxesActionsNames.UPDATE.FAILURE, updateMailboxFailure),
    takeEvery(MailboxesActionsNames.DELETE.REQUEST, deleteMailbox),
    takeEvery(MailboxesActionsNames.DELETE.SUCCESS, deleteMailboxSuccess),
    takeEvery(MailboxesActionsNames.DELETE.FAILURE, deleteMailboxFailure),
  ]);
}
